/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/tabindex-no-positive */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable no-confusing-arrow */
/* eslint-disable vars-on-top */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/no-unused-vars */
import _ from 'lodash';
import React, { ChangeEvent, useState, useContext, useRef } from 'react';
import { Button } from 'react-bootstrap';
import { Tooltip } from '@mui/material';
import './documentUpload.component.css';
import { IUploadresponseData } from '../../interfaces/IUploadData';
import { PriorAuthorizationDomainContext, usePADomainModel } from '../../context/ctxPriorAuthorizationDomain';
import DocumentUploadService from '../../services/DocumentUpload/documentUpload.service';
import { PriorAuthorizationDomain, UploadedFilesInfo, FilesInfo } from '../../interfaces/PriorAuthorizationDomain';

interface DocumentUploadProps {
  index: number
  items: any
  serviceRequestId: string
  uploadedDocs?: UploadedFilesInfo[]
  domainObj?: PriorAuthorizationDomain
}

interface FileUploadStatus {
  file: File,
  status: boolean | null,
  errorMessage: string
}

const DocumentUpload: React.FC<DocumentUploadProps> = ({ index, items, serviceRequestId, uploadedDocs, domainObj }) => {
  const maxNumberOfFileAllowed: number = 10;
  const maxFileSizeAllowedInMB: number = 20;
  const fileuploadCtrl = useRef(null);
  const { priorAuthorizationDomain } = useContext(PriorAuthorizationDomainContext);
  const updatedPriorAuthorizationDomain: PriorAuthorizationDomain = domainObj ? domainObj : priorAuthorizationDomain;
  const [uploadedDocsList, setUploadedDocsList] = useState<FilesInfo[] | []>(uploadedDocs ? (uploadedDocs.length === 1 ? uploadedDocs[0].files : []) : []);
  const [selectedFiles, setSelectedFiles] = useState<Array<FileUploadStatus>>([]);
  const [uploadStatus, setUploadStatus] = useState<string>('');
  const [isUploadInProgress, setIsUploadInProgress] = useState<boolean>(false);
  const [isDeleteInProgress, setIsDeleteInProgress] = useState<boolean>(false);

  const { updateFilesUploadedValidationStatus } = usePADomainModel();

  const handleChange = async (event: any) => {
    if (event.target.files && event.target.files.length > 0) {
      const allowedExtensions = ['PDF', 'JPG', 'JPEG', 'TIFF', 'TIF', 'PNG', 'DOC', 'DOCX', 'TXT', 'GIF', 'XLS', 'XLSX'];
      const maxFileSize = maxFileSizeAllowedInMB * 1024 * 1024;

      // File count
      if ((event.target.files.length + uploadedDocsList.length + selectedFiles.length) > maxNumberOfFileAllowed) {
        setUploadStatus(`Max ${maxNumberOfFileAllowed} files can be uploaded.`);
        return;
      }

      // File extension check
      const filesWithUnsupportedExtension = _.filter(event.target.files, (item) => {
        const selectedFileExtension = item.name.split('.').pop().toUpperCase();
        return !allowedExtensions.includes(selectedFileExtension);
      });

      if (filesWithUnsupportedExtension.length > 0) {
        const fileNames = _.map(filesWithUnsupportedExtension, 'name').join(', ');
        setUploadStatus(`File format not supported. Files: ${fileNames}`);
        return;
      }

      // File size check
      const filesWithMaxFileSize = _.filter(event.target.files, (item) => item.size > maxFileSize);
      if (filesWithMaxFileSize.length > 0) {
        const fileNames = _.map(filesWithMaxFileSize, 'name').join(', ');
        setUploadStatus(`File size exceeds ${maxFileSizeAllowedInMB} MB. Please select a smaller file. Files: ${fileNames}`);
        return;
      }

      const fileList = _.map(event.target.files, (file) => ({
        file,
        status: null,
        errorMessage: '',
      } as FileUploadStatus));

      setSelectedFiles((prevFiles) => ([...prevFiles, ...fileList]));
      updateFilesUploadedValidationStatus((index + 1).toString(), fileList.length === 0);

      setUploadStatus('');
    }
  };

  const uploadDocument = async (fileDetails: FileUploadStatus) => {
    try {
      const cignaRequiredMetaData = {
        documentReceivedDate: new Date(),
        memberDateOfBirth: new Date(updatedPriorAuthorizationDomain.priorAuthorizationDomainHeader.memberDOB),
        memberFirstName: updatedPriorAuthorizationDomain.priorAuthorizationDomainHeader.memberFirstName ? updatedPriorAuthorizationDomain.priorAuthorizationDomainHeader.memberFirstName : 'memberFirstName',
        memberLastName: updatedPriorAuthorizationDomain.priorAuthorizationDomainHeader.memberLastName,
        memberId: updatedPriorAuthorizationDomain.priorAuthorizationDomainHeader.memberId,
        transactionID: updatedPriorAuthorizationDomain.transactionId,
        isAdditionalDocumentUpload: updatedPriorAuthorizationDomain.authorizationStatus ? (updatedPriorAuthorizationDomain.authorizationStatus.toUpperCase() === 'PEND' ? true : false) : false,
        groupId: updatedPriorAuthorizationDomain.groupId,
        authorizationStatus: updatedPriorAuthorizationDomain.authorizationStatus,
        levelOfUrgency: updatedPriorAuthorizationDomain.authorizationStatus ? (updatedPriorAuthorizationDomain.authorizationStatus.toUpperCase() === 'PEND' ? updatedPriorAuthorizationDomain.priorAuthorizationDomianDetails[0].levelOfUrgency : '') : '',
        priorAuthorizationId: updatedPriorAuthorizationDomain.priorAuthorizationId,
      };
      const filesInfo = {
        groupingKey: updatedPriorAuthorizationDomain.groupingKey,
        contextKey: serviceRequestId,
        sourceSystem: updatedPriorAuthorizationDomain.sourceSystemId ? updatedPriorAuthorizationDomain.sourceSystemId : 'sourceSystemId',
        files: [],
        cignaRequiredMetaData,
      };

      const response = await DocumentUploadService.upload(filesInfo, fileDetails.file) as IUploadresponseData;

      setSelectedFiles((prevList) => {
        const list = [...prevList];
        const uploadedFile = _.find(list, (file: FileUploadStatus) => file.file.name === fileDetails.file.name);
        if (uploadedFile) {
          uploadedFile.status = response.files[0].success;
          uploadedFile.errorMessage = response.files[0].errors.join(', ');
        }
        return list;
      });

      if (response.files.length > 0 && response.files[0].errors.length === 0 && response.files[0].success === true) {
        const uploadeDocument: FilesInfo = {
          fileName: response.files[0].fileName,
          amsObjectValetId: response.files[0].amsObjectValetId,
          objectValetId: response.files[0].objectValetId,
          status: response.files[0].status,
        };
        setUploadedDocsList((prevFileArray) => [...prevFileArray, uploadeDocument]);
      }
    } catch (error) {
      setSelectedFiles((prevList) => {
        const list = [...prevList];
        const uploadedFile = _.find(list, (file: FileUploadStatus) => file.file.name === fileDetails.file.name);
        if (uploadedFile) {
          uploadedFile.status = false;
          uploadedFile.errorMessage = `${error} Please try again.`;
        }
        return list;
      });
      setUploadStatus(`${error} Please try again.`);
    }
  };

  const handleUploads = async () => {
    setUploadStatus('');
    if (selectedFiles.length === 0) {
      return;
    }

    setIsUploadInProgress(true);

    await Promise.all(selectedFiles.map(async (file) => {
      await uploadDocument(file);
    }));

    if (fileuploadCtrl.current) {
      (fileuploadCtrl.current as any).value = '';
      setSelectedFiles([]);
    }
    setIsUploadInProgress(false);
    updateFilesUploadedValidationStatus((index + 1).toString(), selectedFiles.length !== 0);
  };

  const handleDelete = async (deletedUploadedFile: FilesInfo) => {
    setIsDeleteInProgress(true);
    const response = await DocumentUploadService.deleteFile(deletedUploadedFile.amsObjectValetId);
    if (response === 'File marked for deletion') {
      setUploadedDocsList((prevFiles) => prevFiles ? prevFiles.filter((file) => file !== deletedUploadedFile) : []);
    }
    setIsDeleteInProgress(false);
  };

  const documentationRules = (
        <div>
            <ul className="my-1">
                <li>Attach up to {maxNumberOfFileAllowed} files</li>
                <li>Each file with a maximum size of {maxFileSizeAllowedInMB}MB.</li>
                <li>Accepted file types: pdf, .jpg, .jpeg, .tif, .tiff, .png, .doc, .docx, .txt, .gif, .xls, and .xlsx.</li>
            </ul>
        </div>
  );

  return (
        <div>
            <div className="form-group mb-3 mt-3">
                <div className="d-flex align-items-right gap-1">
                    <p className="fw-bold mb-0 mr-3">Supporting Documentation</p>
                    <Tooltip title={documentationRules}>
                        <i className="fa fa-info-circle mt-1" aria-hidden="true" />
                    </Tooltip>
                </div>
                <div className="input-group mt-3">
                    <input type="file" multiple className="form-control-file" ref={fileuploadCtrl} style={{ display: 'none' }} id={`inputGroupFile${index}`} tabIndex={60} onChange={handleChange} data-testid="file-input" readOnly />
                    <label className="custom-file-label" htmlFor="file" data-testid="selectedFileName">
                        <div className="custom-textbox">
                            {selectedFiles.length > 0
                              ? selectedFiles.map((file) => (file.file.name)).join(', ') : 'Choose file...'}
                        </div>
                    </label>
                    <Button variant="outline-secondary" onClick={() => (fileuploadCtrl.current as any).click()} disabled={isUploadInProgress || uploadedDocsList.length >= maxNumberOfFileAllowed}>
                        Browse
                    </Button>
                    <Button variant="outline-secondary" onClick={handleUploads} disabled={selectedFiles.length === 0 || isUploadInProgress}>
                    {
                        !isUploadInProgress && <span>Upload</span>
                    }
                    {
                        isUploadInProgress
                        && <span>Uploading... <div className="spinner-border text-primary spinner-border-sm" /></span>
                    }
                    </Button>
                </div>
                {uploadStatus && <p style={{ color: 'red' }}>{uploadStatus}</p>}
                 {selectedFiles
                 && selectedFiles.length > 0
                 && <p style={{ color: 'red' }}>
                 Files are ready to upload. Please select ‘Upload’ button to proceed.
                    </p>}
            </div>
            <div className="row">
                {
                    uploadedDocsList && uploadedDocsList.length > 0
                    && <div className="col-4 mb-3">
                        <p className="fw-bold mb-0">
                            Uploaded Files
                            {
                                <span className="ps-2" data-testid="txtNumberOfDocuments">({uploadedDocsList.length}/{maxNumberOfFileAllowed})</span>
                            }
                            {
                                isDeleteInProgress
                                && <span className="ms-2">(Deleting...<div className="ms-2 spinner-border text-primary spinner-border-sm" />)</span>
                            }
                        </p>
                        <div data-testid="file-list" className="col-12">
                            <ul className="list-group list-group-flush bg-transparent font-size-sm filelist">
                                {Array.from(uploadedDocsList).map((uploadedFile) => (
                                    <li className="list-group-item" key={uploadedFile.amsObjectValetId}>
                                        <div className="">
                                            <button type="button" disabled={isDeleteInProgress} className="fas fa-times-circle fa-sm upload-buttonimg" data-testid={uploadedFile.fileName} onClick={() => handleDelete(uploadedFile)} />
                                            <span className="ms-2 ">{uploadedFile.fileName}</span>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                       </div>
                }

                {
                    selectedFiles && selectedFiles.length > 0
                    && <div className="col-6 mb-3">
                        <p className="fw-bold mb-0">
                            {
                                !isUploadInProgress
                                && <span>Files ready for upload</span>
                            }
                            {
                                isUploadInProgress
                                && <span>Uploading Files</span>
                            }
                            <span className="ps-2" data-testid="txtNumberOfDocumentsUploading">({selectedFiles.length})</span>
                        </p>
                        <div data-testid="file-list-select-uploading" className="col-12">
                            <ul className="list-group list-group-flush bg-transparent font-size-sm filelist">
                                {Array.from(selectedFiles).map((selectedFile) => (
                                    <li className="list-group-item ps-0" key={selectedFile.file.name}>
                                        <div className="">
                                            <span className="ms-2">
                                                {
                                                    isUploadInProgress === false && selectedFile.status === null
                                                    && <i className="fa fa-upload mt-1 me-2" />
                                                }
                                                {
                                                    isUploadInProgress && selectedFile.status === null
                                                    && <i className="fa fa-upload mt-1 me-2 fa-bounce" />
                                                }
                                                {
                                                    selectedFile.status === true
                                                    && <i className="fa fa-check-circle mt-1 me-2 fa-fw fa-md fas text-success" />
                                                }
                                                {
                                                    selectedFile.status === false
                                                    && <i className="fa fa-xmark-circle mt-1 me-2 fa-fw fa-md fas text-danger" />
                                                }
                                            </span>
                                            <span>{selectedFile.file.name}</span>
                                            {
                                                selectedFile.status === false
                                                && <span className="ms-2 text-danger">Uploaded failed. Message: ${selectedFile.errorMessage}</span>
                                            }
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                       </div>
                }
            </div>
        </div>
  );
};

export default DocumentUpload;
